import axios from "../../../../../../api/axiosInstance";
import {
  FetchProductStoreOrdersRequest,
  FetchProductStoreOrdersResponse,
} from "./types";

export const fetchProductStoreOrders = async (
  params: FetchProductStoreOrdersRequest,
  signal?: AbortSignal,
): Promise<FetchProductStoreOrdersResponse> => {
  const response = await axios.get<FetchProductStoreOrdersResponse>(
    "/api/private/product-store/orders",
    { params, signal },
  );
  return response.data;
};
